import moment from 'ct-moment';

// Returns "yesterday" in YYYY-MM-DD format

export const getInitialRangeEndDateWrapper = (timeProvider = moment) => {
  return () => timeProvider().subtract('days', 1).format('YYYY-MM-DD');
};

export default getInitialRangeEndDateWrapper(moment);
